interface EventRouteIdentity {
  id?: number | null;
  byProfileTagName?: string | null;
}

export function eventDetailsRoute(
  event: EventRouteIdentity
): Array<string | number> | null {
  const eventId = validEventId(event.id);
  const tagName = event.byProfileTagName?.trim();
  if (eventId == null || !tagName) return null;

  return ['/profile/view-virtual-event', tagName, eventId];
}

export function eventDetailsUrl(
  event: EventRouteIdentity,
  origin: string
): string | null {
  const eventId = validEventId(event.id);
  const tagName = event.byProfileTagName?.trim();
  if (eventId == null || !tagName) return null;

  return `${origin}/profile/view-virtual-event/${encodeURIComponent(
    tagName
  )}/${eventId}`;
}

export function eventLandingUrl(
  landingPage: { eventId?: number | null; slug?: string | null } | null,
  expectedEventId: number,
  origin: string
): string | null {
  const slug = landingPage?.slug?.trim();
  if (landingPage?.eventId !== expectedEventId || !slug) return null;

  return `${origin}/events/${expectedEventId}/${encodeURIComponent(slug)}`;
}

function validEventId(eventId: number | null | undefined): number | null {
  return Number.isInteger(eventId) && Number(eventId) > 0
    ? Number(eventId)
    : null;
}
